import React from 'react';
import { Modal } from 'antd';

const UnderDevelopmentModal = ({ visible, onCancel }) => {
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      centered
    >
      <div className="p-6 text-center">
        <h2 className="text-2xl font-bold mb-4">Booking Under Development</h2>
        <p className="mb-4">
          We are currently working on developing a seamless checkout experience for you.
        </p>
        <p className="mb-4">
          To check availability and make a booking, please contact us directly:
        </p>
        <div className="mb-4">
          <p><strong>Phone:</strong> <a href="tel:+91-9586900007">+91-9586900007</a></p>
          <p><strong>Email:</strong> <a href="mailto:hello@girglades.com">hello@girglades.com</a></p>
        </div>
        <p className="mt-6 text-sm text-gray-500">
          We apologize for any inconvenience and appreciate your understanding.
        </p>
      </div>
    </Modal>
  );
};

export default UnderDevelopmentModal;
